const TOKEN_KEY = 'token'

function safeRead(storage: Storage): string {
  try { return storage.getItem(TOKEN_KEY) || '' } catch { return '' }
}

export function getAuthToken(): string {
  if (typeof window === 'undefined') return ''
  return safeRead(window.sessionStorage) || safeRead(window.localStorage)
}

export function authTokenIsPersistent(): boolean {
  if (typeof window === 'undefined') return false
  return !!safeRead(window.localStorage)
}

export function setAuthToken(token: string, persistent = false): void {
  if (typeof window === 'undefined') return
  clearAuthToken()
  if (!token) return
  const storage = persistent ? window.localStorage : window.sessionStorage
  storage.setItem(TOKEN_KEY, token)
}

export function replaceAuthToken(token: string): void {
  setAuthToken(token, authTokenIsPersistent())
}

export function clearAuthToken(): void {
  if (typeof window === 'undefined') return
  try { window.sessionStorage.removeItem(TOKEN_KEY) } catch {}
  try { window.localStorage.removeItem(TOKEN_KEY) } catch {}
}
